/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sport_CyclingInputs */

const en_ui_sport_cycling = /** @type {(inputs: Ui_Sport_CyclingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycling`)
};

const de_ui_sport_cycling = /** @type {(inputs: Ui_Sport_CyclingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radfahren`)
};

/**
* | output |
* | --- |
* | "Cycling" |
*
* @param {Ui_Sport_CyclingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sport_cycling = /** @type {((inputs?: Ui_Sport_CyclingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sport_CyclingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sport_cycling(inputs)
	return de_ui_sport_cycling(inputs)
});